module.exports = __webpack_public_path__ + "static/patrick-0cb350cb2204696593acc9cf895b2189.jpg";